import Resource from '@/api/resources/Resource'

class MagazineInformationServices extends Resource {
    async getAllConfiguratedMagazines(laboratoryId) {
        return this.axios.get(`/common/laboratories/${laboratoryId}/allConfiguredMagazines`).then(response => response.data)
    }

    async getFilteredMagazines(laboratoryId, priorityId, sampleTypeId, topographicCodeId) {
        const params = {
            priorityId,
            sampleTypeId,
            topographicCodeId
        }
        return this.axios.get(`/common/laboratories/${laboratoryId}/filterMagazines`, { params }).then(response => response.data)
    }
}

export default new MagazineInformationServices()
